<template>
  <div
    class="qingsu-empty-wrap"
  >
    <p class="txt">没找到符合条件的倾听师～</p>
    <v-touch class="view-all-teacher" @tap="$emit('checkAll')">
      <span>查看全部倾听师</span>
      <i class="yxl-font yxl-font-skip"></i>
    </v-touch>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.qingsu-empty-wrap {
  // top: 192px;
  // left: 50%;
  // box-sizing: border-box;
  // @include fixedPcCenter();
  height: 100vh;
  padding-top: 272px;
  box-sizing: border-box;
  background-color: #fff;
  .txt {
    font-size: 30px;
    color: #999;
    text-align: center;
    margin-bottom: 36px;
  }
  .view-all-teacher {
    font-size: 28px;
    color: #ff745b;
    text-align: center;
    .yxl-font-skip {
      position: relative;
      top: -10px;
      font-size: 20px;
      display: inline-block;
      transform: scale(0.8);
    }
  }
}
</style>
